import service from '@/utils/request'
// 获取未发货的订单明细
export function getListRemainGreatThanZero(param) {
	return service.request({
		method: 'POST',
		url: '/app/orderMx/getListRemainGreatThanZero',
		data: param
	})
}
// 获取送货单列表
export function getShList(param) {
	return service.request({
		method: 'POST',
		url: '/app/sh/shList',
		data: param
	})
}
// 新增送货单
export function addDeliverOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/shMx/addList',
		data: param
	})
}

// 获取送货单信息
export function getShById(param) {
	return service.request({
		method: 'POST',
		url: '/app/sh/shById',
		data: param
	})
}

// 获取送货单明细
export function getShMxList(param) {
	return service.request({
		method: 'POST',
		url: '/app/shMx/shMxList',
		data: param
	})
}

// 获取送货单明细 保存 上
export function saveTopEdit(param) {
	return service.request({
		method: 'POST',
		url: '/app/sh/edit',
		data: param
	})
}

// 获取送货单明细 保存 上
export function updateList(param) {
	return service.request({
		method: 'POST',
		url: '/app/shMx/updateList',
		data: param
	})
}

// 待发布送货单 变更为 送货中
export function publicDeliverOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/sh/publicDeliverOrder',
		data: param
	})
}

// 采购员签收 收货单 确认收货
export function confirmDeliverOrder(param) {
	return service.request({
		method: 'POST',
		url: '/app/sh/confirmDeliverOrder',
		data: param
	})
}










